module.exports = __webpack_public_path__ + "img/c05_unittechlegionarychampion_Normal_ua.fcfa0244.webp";